(() => {
  const quote=document.querySelector('[data-oil-quote]');
  if(!quote)return;
  const root=document.querySelector('.dwell-art-product');
  const labels=JSON.parse(document.getElementById('AlphaConversionLabels')?.textContent||'{}');
  const form=quote.querySelector('form');
  const name=quote.querySelector('#AlphaOilQuoteName'),email=quote.querySelector('#AlphaOilQuoteEmail');
  const sizeInput=quote.querySelector('[data-oil-quote-size]'),urlInput=quote.querySelector('[data-oil-quote-url]');
  const countryInput=quote.querySelector('[data-oil-quote-country]'),bodyInput=quote.querySelector('[data-oil-quote-body]');
  const selection=quote.querySelector('[data-oil-quote-selection]'),error=quote.querySelector('[data-oil-quote-error]');
  const initialSize=new URLSearchParams(location.search).get('quote_size');
  let restored=!/^\d{2,5}x\d{2,5}$/.test(initialSize||''),ready=false,focused=false;
  const setText=(node,value)=>{if(node&&node.textContent!==value)node.textContent=value;};
  const details=()=>{
    const button=root?.querySelector('[data-aap-sizes] button[aria-pressed="true"]');
    const dimensions=/^hand-painted-oil::(\d+(?:\.\d+)?)::(\d+(?:\.\d+)?)$/.exec(button?.dataset.value||'');
    if(!dimensions)return null;
    const width=Number(dimensions[1]),height=Number(dimensions[2]);
    if(!(width>0&&height>0))return null;
    const number=new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:1});
    const size=number.format(width/10)+' × '+number.format(height/10)+' cm';
    const url=new URL(quote.dataset.productUrl,location.origin);
    url.searchParams.set('art_type','oil');url.searchParams.set('art_finish','rolled');
    url.searchParams.set('quote_size',width+'x'+height);
    const country=root.querySelector('[data-aap-country]')?.selectedOptions[0]?.textContent.trim()||'';
    return {size,url:url.href,country,width,height};
  };
  const focus=()=>{if(quote.hidden)return;quote.scrollIntoView({behavior:'smooth',block:'center'});(quote.querySelector('[data-oil-quote-success]')||name).focus({preventScroll:true});};
  const sync=()=>{
    const oil=document.body.dataset.artworkBrowse==='oil';
    if(quote.hidden===oil)quote.hidden=!oil;
    const priceNote=root?.querySelector('[data-oil-price-note]');if(priceNote&&priceNote.hidden===oil)priceNote.hidden=!oil;
    if(!oil)return;
    if(!restored&&root?.querySelector('.aap-configurator')?.getAttribute('aria-busy')==='false'){
      const [width,height]=initialSize.split('x');
      const button=root.querySelector('[data-aap-sizes] button[data-value="hand-painted-oil::'+Number(width)+'::'+Number(height)+'"]');
      if(button){restored=true;if(button.getAttribute('aria-pressed')!=='true')button.click();}
    }
    root.querySelectorAll('[data-aap-sizes] button[data-value^="hand-painted-oil::"] > span').forEach(line=>{
      const money=line.querySelector('.money');
      if(!money)return;
      const prefix=labels.quote_from+' ';
      if(line.firstChild?.nodeType===3&&line.firstChild.textContent!==prefix)line.firstChild.textContent=prefix;
    });
    const sizes=root.querySelector('[data-aap-step="size"]');
    if(sizes&&!sizes.querySelector('[data-oil-price-note]')){
      const note=document.createElement('p');note.dataset.oilPriceNote='';note.textContent=labels.quote_note;note.className='acv-oil-quote__note';sizes.append(note);
    }
    const data=details();ready=!!data;
    quote.querySelectorAll('[data-oil-quote-email],[data-oil-quote-whatsapp]').forEach(button=>{if(button.disabled===ready)button.disabled=!ready;});
    if(data){
      sizeInput.value=data.size;urlInput.value=data.url;countryInput.value=data.country;
      setText(selection,quote.dataset.productTitle+' · '+data.size);
      const returnTo=form.querySelector('[name="return_to"]');
      if(returnTo){const url=new URL(data.url);url.searchParams.set('contact_posted','true');returnTo.value=url.pathname+url.search+'#AlphaOilQuote';}
    }else{sizeInput.value='';setText(selection,labels.quote_choose_size);}
    if(!focused&&(quote.querySelector('[data-oil-quote-success],.acv-oil-quote__errors:not([hidden])')||location.hash==='#AlphaOilQuote')){focused=true;requestAnimationFrame(focus);}
  };
  const prepare=()=>{
    sync();
    if(!ready){setText(error,labels.quote_choose_size);error.hidden=false;return null;}
    if(!name.value.trim()){name.value='';name.reportValidity();return null;}
    if(!form.reportValidity())return null;
    error.hidden=true;
    const message=[labels.quote_subject,labels.quote_first_name+': '+name.value.trim(),labels.quote_email+': '+email.value.trim(),labels.quote_product+': '+quote.dataset.productTitle,labels.quote_size+': '+sizeInput.value,urlInput.value];
    if(countryInput.value)message.push(labels.quote_country+': '+countryInput.value);
    bodyInput.value=message.join('\n');return bodyInput.value;
  };
  form.addEventListener('submit',event=>{if(document.body.dataset.artworkBrowse!=='oil'||!prepare())event.preventDefault();});
  quote.querySelector('[data-oil-quote-whatsapp]').addEventListener('click',()=>{
    const message=prepare();if(!message)return;
    const url=new URL('https://wa.me/'+quote.dataset.whatsapp);url.searchParams.set('text',message);
    window.open(url.href,'_blank','noopener,noreferrer');
  });
  window.addEventListener('click',event=>{
    if(document.body.dataset.artworkBrowse==='oil'&&event.target.closest?.('[data-aap-checkout]')){event.preventDefault();event.stopImmediatePropagation();focus();}
  },true);
  window.AlphaOilQuote={element:quote,sync,focus};
})();
